import useTypedSelector from "@hooks/useTypedSelector";
import { useEffect, useRef } from "react";
import { removeAppLoadingSkeleton } from "./removeAppLoadingSkeleton";

/** Removes #app-loading-skeleton when Redux hides it. */
const AppLoadingSkeletonRemover = () => {
  const isVisible = useTypedSelector((s) => s.ui.appLoadingSkeletonVisible);
  const isRemoved = useRef(false);

  useEffect(() => {
    if (isRemoved.current || isVisible) return;
    isRemoved.current = true;
    return removeAppLoadingSkeleton();
  }, [isVisible]);

  return null;
};
export default AppLoadingSkeletonRemover;
